
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as icons_45pagerj7JZzu6YScG_DzxbYfziV9BMZiytIQqgGsMVMlM_45gUMeta } from "/builds/robustastudio/midea/miraco-website/node_modules/.pnpm/@nuxtjs+svg-sprite@1.0.2_magicast@0.3.5/node_modules/@nuxtjs/svg-sprite/dist/runtime/components/icons-page.vue?macro=true";
import { default as cartLsX3nyRkiCBl3gP9FFca7Zuf7v2dETCcioJHQZwSb7wMeta } from "/builds/robustastudio/midea/miraco-website/pages/cart.vue?macro=true";
import { default as testhceFpg9nFBUOa10antTwiZ9KnsnNQqE5tSSGArt4Ft8Meta } from "/builds/robustastudio/midea/miraco-website/pages/test.vue?macro=true";
import { default as dealsJNmOl9WrQgykW2uSMNhh10MbgkGa_7CXRRkDnA8z5I0Meta } from "/builds/robustastudio/midea/miraco-website/pages/deals.vue?macro=true";
import { default as errorK021GwYikAH9DnS7JuWLTUgBGZWdNLLYik2KHYeuXj4Meta } from "/builds/robustastudio/midea/miraco-website/pages/error.vue?macro=true";
import { default as indexWufGqQU_XXddXGUAhO9941dirNmUbHGatbnkmVyBNLIMeta } from "/builds/robustastudio/midea/miraco-website/pages/index.vue?macro=true";
import { default as login_QKShEyXpaFWJKA6eJrrclPEdbmUMqqMZnYM_WhghXQMeta } from "/builds/robustastudio/midea/miraco-website/pages/login.vue?macro=true";
import { default as _91name_93Rra5TmSEbfOtftkTCrKx_U3VNcP9v_45W3j1rQgXj8Q0IMeta } from "/builds/robustastudio/midea/miraco-website/pages/search/[name].vue?macro=true";
import { default as search7hyLctR4Qo_a4F0nyP_452N4cbAOO0hemoRBF9mIdUiq0Meta } from "/builds/robustastudio/midea/miraco-website/pages/search.vue?macro=true";
import { default as storesOxF7LTaF24lz70jO_Yt98DFknKOcldSEL8tM8CXHpFIMeta } from "/builds/robustastudio/midea/miraco-website/pages/stores.vue?macro=true";
import { default as indexEPdIAEGqioZumijpk6EZ7Ee9yPJQXXa9k1RPQPkElWwMeta } from "/builds/robustastudio/midea/miraco-website/pages/account/index.vue?macro=true";
import { default as devices3peGGX06lAXil3pYqmI212wr1bpjoMlsvdTbwuHiZGMMeta } from "/builds/robustastudio/midea/miraco-website/pages/account/devices.vue?macro=true";
import { default as wishlistoxzhzKdA_cTifgcS1Y23VqeZVfFnztmPGBkGi35NoFcMeta } from "/builds/robustastudio/midea/miraco-website/pages/account/wishlist.vue?macro=true";
import { default as emailfrFnqtsgtkOaXp696mzrPiHSt2Szx1CFC0dAv_76XqwMeta } from "/builds/robustastudio/midea/miraco-website/pages/account/edit/email.vue?macro=true";
import { default as index40maIRfYJx6NRlYGLwEEcYcN79ZIXewapYw6On4YDEEMeta } from "/builds/robustastudio/midea/miraco-website/pages/account/edit/index.vue?macro=true";
import { default as _91id_93oRErcplTWa7Dh6ig6PqqAPzR_45KoLvKQf5FZRBqCfbZQMeta } from "/builds/robustastudio/midea/miraco-website/pages/account/orders/[id].vue?macro=true";
import { default as indexS__0RLtu8oMvSV8dI_uUzYCpHMdBBG5ImlMomRck3skMeta } from "/builds/robustastudio/midea/miraco-website/pages/account/orders/index.vue?macro=true";
import { default as new82EA1pJvb78qCOc2rnzvvsQ5fT3FUCXQ_45XmjEXLnkfUMeta } from "/builds/robustastudio/midea/miraco-website/pages/account/addresses/new.vue?macro=true";
import { default as passwordpCS75kbK31ILM3bigpP9N9JY_45SFDzx9Yrxvzzlhxi20Meta } from "/builds/robustastudio/midea/miraco-website/pages/account/edit/password.vue?macro=true";
import { default as indexqgfMBTj1TwSOyzrFqNnIgz4H2tJlTgO4pmI8ikI5LtQMeta } from "/builds/robustastudio/midea/miraco-website/pages/account/addresses/index.vue?macro=true";
import { default as _91id_93te_5N6gJIwBDrW6Ajx6ZynwH3v_p7GnRVNP3cQ6uu7AMeta } from "/builds/robustastudio/midea/miraco-website/pages/account/appointments/[id].vue?macro=true";
import { default as indexOhY4r_Yon7Nm4mcjn9Eompcx_vrikcchaagDul4PdkwMeta } from "/builds/robustastudio/midea/miraco-website/pages/account/appointments/index.vue?macro=true";
import { default as editPY_45xc9CVqP0iiSeHi9Hw0GjS3Bx9BL_dxhnbnxO44D8Meta } from "/builds/robustastudio/midea/miraco-website/pages/account/addresses/[id]/edit.vue?macro=true";
import { default as accountqCj22ML49l2nREpP_45sK2NyWWPmPjBm2Jaguy3u_45_J48Meta } from "/builds/robustastudio/midea/miraco-website/pages/account.vue?macro=true";
import { default as careersJIWtf_xMCbJKd4uJpL8rIbXmpn8tinFIGqZJ0qQrF_sMeta } from "/builds/robustastudio/midea/miraco-website/pages/careers.vue?macro=true";
import { default as compareFCbJ0sC1DInvZaOzXOZu6QJG9GPCTl55PcjP4ae8JWAMeta } from "/builds/robustastudio/midea/miraco-website/pages/compare.vue?macro=true";
import { default as contactijwQR7ctbKvM4oGkbp2oMOBpJ9VqzYOhGnlcDp_451WdcMeta } from "/builds/robustastudio/midea/miraco-website/pages/contact.vue?macro=true";
import { default as about_45usint4yLyyU_ajWYotR33m7WwV6ELCnuR6hgwg_FpIY10Meta } from "/builds/robustastudio/midea/miraco-website/pages/about-us.vue?macro=true";
import { default as best_45fitWhkhdDMG4a9w8zGXw5Ou0YY88L_451uULqj30AlM489YMMeta } from "/builds/robustastudio/midea/miraco-website/pages/best-fit.vue?macro=true";
import { default as productswxit_Ng_45Jr_f6rTruf9P1E2LhZm2neQiyT3vAfihUVkMeta } from "/builds/robustastudio/midea/miraco-website/pages/products.vue?macro=true";
import { default as registerdzyHmJeOLb8a5HpCr3dqWWWYNOglDZ7GyWjWoFphFWEMeta } from "/builds/robustastudio/midea/miraco-website/pages/register.vue?macro=true";
import { default as indexKueYAYe_wjfKRERgogVe4zdhxHWOdFnYEbDb_VWo6YkMeta } from "/builds/robustastudio/midea/miraco-website/pages/faqs/index.vue?macro=true";
import { default as smart_45homeEypOLMvY1lZkrQ6dbOfsl4eIKuroZN1ZGDOfnujudmgMeta } from "/builds/robustastudio/midea/miraco-website/pages/smart-home.vue?macro=true";
import { default as _91slug_93FJyHP_453Npw3Ef5dbe_OGkXDj2WZ0yrLbGAI3om6EkwIMeta } from "/builds/robustastudio/midea/miraco-website/pages/faqs/[slug].vue?macro=true";
import { default as recovery53AVGz6BUryJ540XitZQCpTh_InNFKbae4u9sYUuUcMeta } from "/builds/robustastudio/midea/miraco-website/pages/auth/recover.vue?macro=true";
import { default as indexB9fu5JGo6OHkESyU4_45V_45uUMqSEwZqIMfr9kMTJB33LwMeta } from "/builds/robustastudio/midea/miraco-website/pages/brands/index.vue?macro=true";
import { default as payLuM7xaWOMHdFTNytRNeerOK1lALia__y_45IRrDlDgQRQMeta } from "/builds/robustastudio/midea/miraco-website/pages/checkout/pay.vue?macro=true";
import { default as erroreUjsdm_45gEpxu1IRbfPPKY_45c_45b9MA4KtGIikf6lRMHDMMeta } from "/builds/robustastudio/midea/miraco-website/pages/orders/error.vue?macro=true";
import { default as _91slug_93yrbUVwVK6_45dGa06KurGeg37L0WMORRhLB2s7w_ieuiIMeta } from "/builds/robustastudio/midea/miraco-website/pages/brands/[slug].vue?macro=true";
import { default as warranty_45infoEU_vWD3q4jzil4KDaX5RBcuK1aLpR1v8efXQ_gtWkYEMeta } from "/builds/robustastudio/midea/miraco-website/pages/warranty-info.vue?macro=true";
import { default as privacy_45policyzZAVQ5Wo2u7tvzImP5tRY3zwJC_bC6PIYTDinqjOQTwMeta } from "/builds/robustastudio/midea/miraco-website/pages/privacy-policy.vue?macro=true";
import { default as indexp8c2uezL71amn7jLetjUsS4lxQJPAJdgK1rtcYnmbCsMeta } from "/builds/robustastudio/midea/miraco-website/pages/[...slug]/index.vue?macro=true";
import { default as book_45appointmentkwmmKgQ0kie_8bhkc6P5YmdLh_tNXwtQYXtVlqJum5MMeta } from "/builds/robustastudio/midea/miraco-website/pages/book-appointment.vue?macro=true";
import { default as midea_45smart_45homeMq9Ml1NfK6lx_45B49QIvCyjeDyC8cd9_45EinkqhTnfqS4Meta } from "/builds/robustastudio/midea/miraco-website/pages/midea-smart-home.vue?macro=true";
import { default as register_45productDt9o01889dqLkYni__45wXipRCMGyIfKIyn_sGCJG_yIIMeta } from "/builds/robustastudio/midea/miraco-website/pages/register-product.vue?macro=true";
import { default as shippingjpgsKxLoPzJfC28ifea6HzAnIKuROHSV3PEO1lwPtKAMeta } from "/builds/robustastudio/midea/miraco-website/pages/checkout/shipping.vue?macro=true";
import { default as _91slug_93sOz96TtgL3HHwoIrH5sEQCAkt2ROKbkJlvwRKzQ6jTUMeta } from "/builds/robustastudio/midea/miraco-website/pages/smartHomes/[slug].vue?macro=true";
import { default as carrier_45smart_45homejaRa7WE7JhAWPp0clMLPJK82L1xNAzu6IFTDPiO3lGQMeta } from "/builds/robustastudio/midea/miraco-website/pages/carrier-smart-home.vue?macro=true";
import { default as successQD_45nzmNGTO3cPuXQVBGv1fxQ6hVgYxqKmz9AIbJ64_0Meta } from "/builds/robustastudio/midea/miraco-website/pages/orders/[id]/success.vue?macro=true";
import { default as returns_45and_45refunds947_HX8pqYkq2qr67jhPrKeUQKF8FMkWq5IiOT9l1EsMeta } from "/builds/robustastudio/midea/miraco-website/pages/returns-and-refunds.vue?macro=true";
import { default as indexxpg_45BVp_45xDOcYHt8_45_FfeSIVKaIrk0tQkHGH7kRgy3MMeta } from "/builds/robustastudio/midea/miraco-website/pages/search-manuals/index.vue?macro=true";
import { default as terms_45and_45conditions9pn7mqpXx2urRrk_45gVNtk8PjhbAWcYFKUFdPA5ZnQZkMeta } from "/builds/robustastudio/midea/miraco-website/pages/terms-and-conditions.vue?macro=true";
import { default as TopProductsContainerdgETuD0olpgQNtBcEp3aaT16JdXqxmr4HO_45zpAzoD4AMeta } from "/builds/robustastudio/midea/miraco-website/pages/TopProductsContainer.vue?macro=true";
import { default as _91slug_93cNbGh_Mvq80T_45MwEgKB_Az29qKxqSQPSMmNoAmLfQPgMeta } from "/builds/robustastudio/midea/miraco-website/pages/search-manuals/[slug].vue?macro=true";
import { default as book_45appointment_45intro_45etCMyNUInrn2kXoSCoMf5SQ98s69dJhjAUJuAys058Meta } from "/builds/robustastudio/midea/miraco-website/pages/book-appointment-intro.vue?macro=true";
import { default as register_45product_45intro7_4511HkhjoeNq3rZu991SPrlzPlqT5pkcGRMvfe4hZXoMeta } from "/builds/robustastudio/midea/miraco-website/pages/register-product-intro.vue?macro=true";
import { default as create_45reviewcs29IefFBzzcGOX7_457aDgJuQwE8H2vjCDefWXLNxENEMeta } from "/builds/robustastudio/midea/miraco-website/pages/[...slug]/create-review.vue?macro=true";
import { default as guest_45shippingr45hnZOIbEi52yf4_9AGSt_45ZvDUTYeN6eWJ2HEXExUQMeta } from "/builds/robustastudio/midea/miraco-website/pages/checkout/guest-shipping.vue?macro=true";
import { default as successmQZc66sGvLU1GN8SIVD66NWk1DhERL_45Z8sil8KrLvMoMeta } from "/builds/robustastudio/midea/miraco-website/pages/guest-order/[id]/success.vue?macro=true";
import { default as create_45reviewscehFdy4kEPrPFpbwATYh9JlStJQBPJrtjjO0845kTQMeta } from "/builds/robustastudio/midea/miraco-website/pages/orders/[id]/create-review.vue?macro=true";
export default [
  {
    name: "icons-page___en___default",
    path: "/_icons",
    meta: {"layout":"svg-sprite"},
    component: () => import("/builds/robustastudio/midea/miraco-website/node_modules/.pnpm/@nuxtjs+svg-sprite@1.0.2_magicast@0.3.5/node_modules/@nuxtjs/svg-sprite/dist/runtime/components/icons-page.vue")
  },
  {
    name: "icons-page___en",
    path: "/en/_icons",
    meta: {"layout":"svg-sprite"},
    component: () => import("/builds/robustastudio/midea/miraco-website/node_modules/.pnpm/@nuxtjs+svg-sprite@1.0.2_magicast@0.3.5/node_modules/@nuxtjs/svg-sprite/dist/runtime/components/icons-page.vue")
  },
  {
    name: "cart___en___default",
    path: "/cart",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/cart.vue")
  },
  {
    name: "cart___en",
    path: "/en/cart",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/cart.vue")
  },
  {
    name: "test___en___default",
    path: "/test",
    meta: testhceFpg9nFBUOa10antTwiZ9KnsnNQqE5tSSGArt4Ft8Meta || {},
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/test.vue")
  },
  {
    name: "test___en",
    path: "/en/test",
    meta: testhceFpg9nFBUOa10antTwiZ9KnsnNQqE5tSSGArt4Ft8Meta || {},
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/test.vue")
  },
  {
    name: "deals___en___default",
    path: "/deals",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/deals.vue")
  },
  {
    name: "deals___en",
    path: "/en/deals",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/deals.vue")
  },
  {
    name: "error___en___default",
    path: "/error",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/error.vue")
  },
  {
    name: "error___en",
    path: "/en/error",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/error.vue")
  },
  {
    name: "index___en___default",
    path: "/",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/index.vue")
  },
  {
    name: "login___en___default",
    path: "/login",
    meta: login_QKShEyXpaFWJKA6eJrrclPEdbmUMqqMZnYM_WhghXQMeta || {},
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/login.vue")
  },
  {
    name: "login___en",
    path: "/en/login",
    meta: login_QKShEyXpaFWJKA6eJrrclPEdbmUMqqMZnYM_WhghXQMeta || {},
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/login.vue")
  },
  {
    name: "search___en___default",
    path: "/search",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/search.vue"),
    children: [
  {
    name: "search-name___en___default",
    path: ":name()",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/search/[name].vue")
  }
]
  },
  {
    name: "search___en",
    path: "/en/search",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/search.vue"),
    children: [
  {
    name: "search-name___en",
    path: ":name()",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/search/[name].vue")
  }
]
  },
  {
    name: "stores___en___default",
    path: "/stores",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/stores.vue")
  },
  {
    name: "stores___en",
    path: "/en/stores",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/stores.vue")
  },
  {
    name: accountqCj22ML49l2nREpP_45sK2NyWWPmPjBm2Jaguy3u_45_J48Meta?.name,
    path: "/account",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/account.vue"),
    children: [
  {
    name: "account___en___default",
    path: "",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/account/index.vue")
  },
  {
    name: "account-devices___en___default",
    path: "devices",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/account/devices.vue")
  },
  {
    name: "account-wishlist___en___default",
    path: "wishlist",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/account/wishlist.vue")
  },
  {
    name: "account-edit-email___en___default",
    path: "edit/email",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/account/edit/email.vue")
  },
  {
    name: "account-edit___en___default",
    path: "edit",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/account/edit/index.vue")
  },
  {
    name: "account-orders-id___en___default",
    path: "orders/:id()",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/account/orders/[id].vue")
  },
  {
    name: "account-orders___en___default",
    path: "orders",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/account/orders/index.vue")
  },
  {
    name: "account-addresses-new___en___default",
    path: "addresses/new",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/account/addresses/new.vue")
  },
  {
    name: "account-edit-password___en___default",
    path: "edit/password",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/account/edit/password.vue")
  },
  {
    name: "account-addresses___en___default",
    path: "addresses",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/account/addresses/index.vue")
  },
  {
    name: "account-appointments-id___en___default",
    path: "appointments/:id()",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/account/appointments/[id].vue")
  },
  {
    name: "account-appointments___en___default",
    path: "appointments",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/account/appointments/index.vue")
  },
  {
    name: "account-addresses-id-edit___en___default",
    path: "addresses/:id()/edit",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/account/addresses/[id]/edit.vue")
  }
]
  },
  {
    name: accountqCj22ML49l2nREpP_45sK2NyWWPmPjBm2Jaguy3u_45_J48Meta?.name,
    path: "/en/account",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/account.vue"),
    children: [
  {
    name: "account___en",
    path: "",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/account/index.vue")
  },
  {
    name: "account-devices___en",
    path: "devices",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/account/devices.vue")
  },
  {
    name: "account-wishlist___en",
    path: "wishlist",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/account/wishlist.vue")
  },
  {
    name: "account-edit-email___en",
    path: "edit/email",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/account/edit/email.vue")
  },
  {
    name: "account-edit___en",
    path: "edit",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/account/edit/index.vue")
  },
  {
    name: "account-orders-id___en",
    path: "orders/:id()",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/account/orders/[id].vue")
  },
  {
    name: "account-orders___en",
    path: "orders",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/account/orders/index.vue")
  },
  {
    name: "account-addresses-new___en",
    path: "addresses/new",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/account/addresses/new.vue")
  },
  {
    name: "account-edit-password___en",
    path: "edit/password",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/account/edit/password.vue")
  },
  {
    name: "account-addresses___en",
    path: "addresses",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/account/addresses/index.vue")
  },
  {
    name: "account-appointments-id___en",
    path: "appointments/:id()",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/account/appointments/[id].vue")
  },
  {
    name: "account-appointments___en",
    path: "appointments",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/account/appointments/index.vue")
  },
  {
    name: "account-addresses-id-edit___en",
    path: "addresses/:id()/edit",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/account/addresses/[id]/edit.vue")
  }
]
  },
  {
    name: "careers___en___default",
    path: "/careers",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/careers.vue")
  },
  {
    name: "careers___en",
    path: "/en/careers",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/careers.vue")
  },
  {
    name: "compare___en___default",
    path: "/compare",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/compare.vue")
  },
  {
    name: "compare___en",
    path: "/en/compare",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/compare.vue")
  },
  {
    name: "contact___en___default",
    path: "/contact",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/contact.vue")
  },
  {
    name: "contact___en",
    path: "/en/contact",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/contact.vue")
  },
  {
    name: "about-us___en___default",
    path: "/about-us",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/about-us.vue")
  },
  {
    name: "about-us___en",
    path: "/en/about-us",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/about-us.vue")
  },
  {
    name: "best-fit___en___default",
    path: "/best-fit",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/best-fit.vue")
  },
  {
    name: "best-fit___en",
    path: "/en/best-fit",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/best-fit.vue")
  },
  {
    name: "products___en___default",
    path: "/products",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/products.vue")
  },
  {
    name: "products___en",
    path: "/en/products",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/products.vue")
  },
  {
    name: "register___en___default",
    path: "/register",
    meta: registerdzyHmJeOLb8a5HpCr3dqWWWYNOglDZ7GyWjWoFphFWEMeta || {},
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/register.vue")
  },
  {
    name: "register___en",
    path: "/en/register",
    meta: registerdzyHmJeOLb8a5HpCr3dqWWWYNOglDZ7GyWjWoFphFWEMeta || {},
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/register.vue")
  },
  {
    name: "faqs___en___default",
    path: "/faqs",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/faqs/index.vue")
  },
  {
    name: "faqs___en",
    path: "/en/faqs",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/faqs/index.vue")
  },
  {
    name: "smart-home___en___default",
    path: "/smart-home",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/smart-home.vue")
  },
  {
    name: "smart-home___en",
    path: "/en/smart-home",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/smart-home.vue")
  },
  {
    name: "faqs-slug___en___default",
    path: "/faqs/:slug()",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/faqs/[slug].vue")
  },
  {
    name: "faqs-slug___en",
    path: "/en/faqs/:slug()",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/faqs/[slug].vue")
  },
  {
    name: "auth-recover___en___default",
    path: "/auth/recover",
    meta: recovery53AVGz6BUryJ540XitZQCpTh_InNFKbae4u9sYUuUcMeta || {},
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/auth/recover.vue")
  },
  {
    name: "auth-recover___en",
    path: "/en/auth/recover",
    meta: recovery53AVGz6BUryJ540XitZQCpTh_InNFKbae4u9sYUuUcMeta || {},
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/auth/recover.vue")
  },
  {
    name: "brands___en___default",
    path: "/brands",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/brands/index.vue")
  },
  {
    name: "brands___en",
    path: "/en/brands",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/brands/index.vue")
  },
  {
    name: "checkout-pay___en___default",
    path: "/checkout/pay",
    meta: payLuM7xaWOMHdFTNytRNeerOK1lALia__y_45IRrDlDgQRQMeta || {},
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/checkout/pay.vue")
  },
  {
    name: "checkout-pay___en",
    path: "/en/checkout/pay",
    meta: payLuM7xaWOMHdFTNytRNeerOK1lALia__y_45IRrDlDgQRQMeta || {},
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/checkout/pay.vue")
  },
  {
    name: "orders-error___en___default",
    path: "/orders/error",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/orders/error.vue")
  },
  {
    name: "orders-error___en",
    path: "/en/orders/error",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/orders/error.vue")
  },
  {
    name: "brands-slug___en___default",
    path: "/brands/:slug()",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/brands/[slug].vue")
  },
  {
    name: "brands-slug___en",
    path: "/en/brands/:slug()",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/brands/[slug].vue")
  },
  {
    name: "warranty-info___en___default",
    path: "/warranty-info",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/warranty-info.vue")
  },
  {
    name: "warranty-info___en",
    path: "/en/warranty-info",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/warranty-info.vue")
  },
  {
    name: "privacy-policy___en___default",
    path: "/privacy-policy",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___en",
    path: "/en/privacy-policy",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/privacy-policy.vue")
  },
  {
    name: "slug___en___default",
    path: "/:slug(.*)*",
    meta: indexp8c2uezL71amn7jLetjUsS4lxQJPAJdgK1rtcYnmbCsMeta || {},
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/[...slug]/index.vue")
  },
  {
    name: "slug___en",
    path: "/en/:slug(.*)*",
    meta: indexp8c2uezL71amn7jLetjUsS4lxQJPAJdgK1rtcYnmbCsMeta || {},
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/[...slug]/index.vue")
  },
  {
    name: "book-appointment___en___default",
    path: "/book-appointment",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/book-appointment.vue")
  },
  {
    name: "book-appointment___en",
    path: "/en/book-appointment",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/book-appointment.vue")
  },
  {
    name: "midea-smart-home___en___default",
    path: "/midea-smart-home",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/midea-smart-home.vue")
  },
  {
    name: "midea-smart-home___en",
    path: "/en/midea-smart-home",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/midea-smart-home.vue")
  },
  {
    name: "register-product___en___default",
    path: "/register-product",
    meta: register_45productDt9o01889dqLkYni__45wXipRCMGyIfKIyn_sGCJG_yIIMeta || {},
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/register-product.vue")
  },
  {
    name: "register-product___en",
    path: "/en/register-product",
    meta: register_45productDt9o01889dqLkYni__45wXipRCMGyIfKIyn_sGCJG_yIIMeta || {},
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/register-product.vue")
  },
  {
    name: "checkout-shipping___en___default",
    path: "/checkout/shipping",
    meta: shippingjpgsKxLoPzJfC28ifea6HzAnIKuROHSV3PEO1lwPtKAMeta || {},
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/checkout/shipping.vue")
  },
  {
    name: "checkout-shipping___en",
    path: "/en/checkout/shipping",
    meta: shippingjpgsKxLoPzJfC28ifea6HzAnIKuROHSV3PEO1lwPtKAMeta || {},
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/checkout/shipping.vue")
  },
  {
    name: "smartHomes-slug___en___default",
    path: "/smartHomes/:slug()",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/smartHomes/[slug].vue")
  },
  {
    name: "smartHomes-slug___en",
    path: "/en/smartHomes/:slug()",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/smartHomes/[slug].vue")
  },
  {
    name: "carrier-smart-home___en___default",
    path: "/carrier-smart-home",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/carrier-smart-home.vue")
  },
  {
    name: "carrier-smart-home___en",
    path: "/en/carrier-smart-home",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/carrier-smart-home.vue")
  },
  {
    name: "orders-id-success___en___default",
    path: "/orders/:id()/success",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/orders/[id]/success.vue")
  },
  {
    name: "orders-id-success___en",
    path: "/en/orders/:id()/success",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/orders/[id]/success.vue")
  },
  {
    name: "returns-and-refunds___en___default",
    path: "/returns-and-refunds",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/returns-and-refunds.vue")
  },
  {
    name: "returns-and-refunds___en",
    path: "/en/returns-and-refunds",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/returns-and-refunds.vue")
  },
  {
    name: "search-manuals___en___default",
    path: "/search-manuals",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/search-manuals/index.vue")
  },
  {
    name: "search-manuals___en",
    path: "/en/search-manuals",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/search-manuals/index.vue")
  },
  {
    name: "terms-and-conditions___en___default",
    path: "/terms-and-conditions",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/terms-and-conditions.vue")
  },
  {
    name: "terms-and-conditions___en",
    path: "/en/terms-and-conditions",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/terms-and-conditions.vue")
  },
  {
    name: "TopProductsContainer___en___default",
    path: "/TopProductsContainer",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/TopProductsContainer.vue")
  },
  {
    name: "TopProductsContainer___en",
    path: "/en/TopProductsContainer",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/TopProductsContainer.vue")
  },
  {
    name: "search-manuals-slug___en___default",
    path: "/search-manuals/:slug()",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/search-manuals/[slug].vue")
  },
  {
    name: "search-manuals-slug___en",
    path: "/en/search-manuals/:slug()",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/search-manuals/[slug].vue")
  },
  {
    name: "book-appointment-intro___en___default",
    path: "/book-appointment-intro",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/book-appointment-intro.vue")
  },
  {
    name: "book-appointment-intro___en",
    path: "/en/book-appointment-intro",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/book-appointment-intro.vue")
  },
  {
    name: "register-product-intro___en___default",
    path: "/register-product-intro",
    meta: register_45product_45intro7_4511HkhjoeNq3rZu991SPrlzPlqT5pkcGRMvfe4hZXoMeta || {},
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/register-product-intro.vue")
  },
  {
    name: "register-product-intro___en",
    path: "/en/register-product-intro",
    meta: register_45product_45intro7_4511HkhjoeNq3rZu991SPrlzPlqT5pkcGRMvfe4hZXoMeta || {},
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/register-product-intro.vue")
  },
  {
    name: "slug-create-review___en___default",
    path: "/:slug([^/]*)*/create-review",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/[...slug]/create-review.vue")
  },
  {
    name: "slug-create-review___en",
    path: "/en/:slug([^/]*)*/create-review",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/[...slug]/create-review.vue")
  },
  {
    name: "checkout-guest-shipping___en___default",
    path: "/checkout/guest-shipping",
    meta: guest_45shippingr45hnZOIbEi52yf4_9AGSt_45ZvDUTYeN6eWJ2HEXExUQMeta || {},
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/checkout/guest-shipping.vue")
  },
  {
    name: "checkout-guest-shipping___en",
    path: "/en/checkout/guest-shipping",
    meta: guest_45shippingr45hnZOIbEi52yf4_9AGSt_45ZvDUTYeN6eWJ2HEXExUQMeta || {},
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/checkout/guest-shipping.vue")
  },
  {
    name: "guest-order-id-success___en___default",
    path: "/guest-order/:id()/success",
    meta: successmQZc66sGvLU1GN8SIVD66NWk1DhERL_45Z8sil8KrLvMoMeta || {},
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/guest-order/[id]/success.vue")
  },
  {
    name: "guest-order-id-success___en",
    path: "/en/guest-order/:id()/success",
    meta: successmQZc66sGvLU1GN8SIVD66NWk1DhERL_45Z8sil8KrLvMoMeta || {},
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/guest-order/[id]/success.vue")
  },
  {
    name: "orders-id-create-review___en___default",
    path: "/orders/:id()/create-review",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/orders/[id]/create-review.vue")
  },
  {
    name: "orders-id-create-review___en",
    path: "/en/orders/:id()/create-review",
    component: () => import("/builds/robustastudio/midea/miraco-website/pages/orders/[id]/create-review.vue")
  }
]